import * as React from 'react';
import { IStore } from 'redux/IStore';
import { resetData } from 'modules/onboardingquiz';
import { Modal } from 'components';
import { IModalAction } from 'models/modal';
import { destroy } from 'redux-form';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { HairType } from 'containers/OnboardingQuiz/HairType';
import { HairLength } from 'containers/OnboardingQuiz/HairLength';
import { HairColor } from 'containers/OnboardingQuiz/HairColor';
import { ScalpCondition } from 'containers/OnboardingQuiz/ScalpCondition';
import { ProductBrand } from 'containers/OnboardingQuiz/ProductBrand';
import { HairRelatedGoal } from 'containers/OnboardingQuiz/HairRelatedGoal';
import { SkinProblem } from 'containers/OnboardingQuiz/SkinProblem';
import { EyeColor } from 'containers/OnboardingQuiz/EyeColor';
import { NailsShape } from 'containers/OnboardingQuiz/NailsShape';
import { IUserProfile, IUserProfileAction } from 'models/user/userprofile';
const { connect } = require('react-redux');

interface IProps {
	showHeaderCloseButton?: boolean;
	componentName?:
		| 'HairType'
		| 'HairLength'
		| 'HairColor'
		| 'ScalpCondition'
		| 'ProductBrand'
		| 'HairRelatedGoal'
		| 'SkinProblem'
		| 'EyeColor'
		| 'NailsShape';

	t?: (key: string, options?: any) => string;
	closeModal?: () => IModalAction;
	onSubmit?: (form: IUserProfile) => IUserProfileAction;
}

const componentTable = {
	HairType,
	HairLength,
	HairColor,
	ScalpCondition,
	ProductBrand,
	HairRelatedGoal,
	SkinProblem,
	EyeColor,
	NailsShape,
};

@connect(
	(state: IStore) => {
		return {
			onboardingQuiz: state.onboardingQuiz,
		};
	},
	(dispatch) => ({
		resetData: () => dispatch(resetData()),
		destroy: (form: string) => dispatch(destroy(form)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class OnboardingQuizEdit extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
	}

	private onSubmit(form: IUserProfile) {
		this.props.onSubmit(form);
		this.props.closeModal();
	}

	public render() {
		const { closeModal, showHeaderCloseButton, componentName } = this.props;
		const Component = componentTable[componentName];

		return (
			<Modal
				modalClass="modalOnboardingWrapper modalEdit"
				showHeaderCloseButton={showHeaderCloseButton}
				closeModal={closeModal}
				size="normal"
			>
				{Component ? <Component closeModal={closeModal} onSubmit={this.onSubmit} editMode={true} /> : componentName}
			</Modal>
		);
	}
}

export { OnboardingQuizEdit };
